import React, { useEffect, useState, useRef } from "react";
import "./adminStyles.css";
import { IoSearch } from "react-icons/io5";
import copy_icon from "../../assets/admin/copy_icon.webp";
import AdminSidebar from "./Sidebar/AdminSidebar";
import AdminHeader from "./Header/AdminHeader";
import { getMethod, postMethod } from "../../core/service/common.api";
import apiService from "../../core/service/detail";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import moment from "moment";
import { CSVLink } from "react-csv";
import TokenHistoryPDF from "./tokenpdf";

// import { jsPDF } from 'jspdf';
import { PDFDownloadLink } from "@react-pdf/renderer";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";

function shortenAddress(address, start = 3, end = 4) {
  if (!address) return "";
  return `${address.slice(0, start)}...${address.slice(-end)}`;
}

const UserManagement = () => {
  const [sortFilter, setSortFilter] = useState("APY %");

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(message);
  };
  const copy = async (text, msg) => {
    navigator.clipboard.writeText(text);
    console.log(text, "text");
    showsuccessToast(msg + " copied");
  };

  //login History
  const [userData, setuserData] = useState([]);
  const [userDataCSV, setuserDataCSV] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(""); // e.g., "approved", "pending"

  const handleFilterChange = (e) => {
    const value = e.target.value;
    if (value.length === 1 && value[0] === " ") return;
    setSearchTerm(value);
  };
  useEffect(() => {
    getuserHistoryCSV();
  }, [0]);
  useEffect(() => {
    getuserHistory(currentPage);
  }, [currentPage, searchTerm]);

  const getuserHistory = async (page) => {
    try {
      const UserObj = {
        page: page ? page : currentPage,
        perpage: 5,
        search: searchTerm,
      };
      setLoader(true);
      var data = {
        apiUrl: apiService.tokenManagement,
        payload: UserObj,
      };
      var resp = await postMethod(data);
      setLoader(false);
      if (resp.status == true) {
        setuserData(resp.data);
        console.log(resp.data, "resp.data");
        console.log(userData, "userData");
        setTotalPages(resp.totalPages);
      } else {
        setuserData([]);
      }
    } catch (err) {
      console.log(err, "=-==-");
    }
  };
  const getuserHistoryCSV = async () => {
    try {
      setLoader(true);
      var data = {
        apiUrl: apiService.gettokenHistoryCSV,
      };
      var resp = await postMethod(data);
      setLoader(false);
      setuserDataCSV(resp.data);
    } catch (err) {}
  };
  const handlePageClick = (data) => {
    setCurrentPage(data);
    getuserHistory(data);
  };

  // const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  //     const [windowStart, setWindowStart] = useState(1);
  //     const windowSize = 3;

  //     useEffect(() => {
  //         // Adjust window if currentPage moves outside the visible range
  //         if (currentPage < windowStart) {
  //             setWindowStart(currentPage);
  //         } else if (currentPage >= windowStart + windowSize) {
  //             setWindowStart(currentPage - windowSize + 1);
  //         }
  //     }, [currentPage]);

  //     const renderPageButtons = () => {
  //         const pages = [];
  //         const windowEnd = Math.min(windowStart + windowSize - 1, totalPages);

  //         for (let i = windowStart; i <= windowEnd; i++) {
  //             pages.push(
  //                 <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
  //                     <button className="page-link" onClick={() => onPageChange(i)}>
  //                         {i}
  //                     </button>
  //                 </li>
  //             );
  //         }

  //         return pages;
  //     };

  //     const handlePrevWindow = () => {
  //         if (windowStart > 1) {
  //             const newStart = Math.max(windowStart - windowSize, 1);
  //             setWindowStart(newStart);
  //             onPageChange(newStart);
  //         }
  //     };

  //     const handleNextWindow = () => {
  //         if (windowStart + windowSize <= totalPages) {
  //             const newStart = windowStart + windowSize;
  //             setWindowStart(newStart);
  //             onPageChange(newStart);
  //         }
  //     };

  //     return (
  //         <nav aria-label="Page navigation example">
  //             <ul className="pagination custom_pagination">
  //                 <li className={`page-item ${windowStart === 1 ? "disabled" : ""}`}>
  //                     <button className="page-link" onClick={handlePrevWindow}>
  //                         <FaArrowLeft />
  //                     </button>
  //                 </li>

  //                 {renderPageButtons()}

  //                 <li
  //                     className={`page-item ${windowStart + windowSize > totalPages ? "disabled" : ""
  //                         }`}
  //                 >
  //                     <button className="page-link" onClick={handleNextWindow}>
  //                         <FaArrowRight />
  //                     </button>
  //                 </li>
  //             </ul>
  //         </nav>
  //     );
  // };

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const [windowStart, setWindowStart] = useState(currentPage);
    const windowSize = 3;

    useEffect(() => {
      // Adjust window if currentPage moves outside the visible range
      if (currentPage < windowStart) {
        setWindowStart(currentPage);
      } else if (currentPage >= windowStart + windowSize) {
        setWindowStart(currentPage - windowSize + 1);
      }
    }, [currentPage]);

    const renderPageButtons = () => {
      return (
        <ul className="page_num_wrp">
          {windowStart > 1 ? (
            <li key={windowStart - 1} className={`page-item`}>
              <button
                className="page-link"
                onClick={() => onPageChange(windowStart - 1)}
              >
                {windowStart - 1}
              </button>
            </li>
          ) : null}
          <li
            key={windowStart}
            className={`page-item ${
              currentPage === windowStart ? "active" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => onPageChange(windowStart)}
            >
              {windowStart}
            </button>
          </li>
          {windowStart < totalPages ? (
            <li key={windowStart + 1} className={`page-item`}>
              <button
                className="page-link"
                onClick={() => onPageChange(windowStart + 1)}
              >
                {windowStart + 1}
              </button>
            </li>
          ) : null}
        </ul>
      );
    };

    const handlePrevWindow = () => {
      if (windowStart > 1) {
        const newStart = Math.max(windowStart - 1);
        setWindowStart(newStart);
        onPageChange(newStart);
      }
    };

    const handleNextWindow = () => {
      if (windowStart <= totalPages) {
        const newStart = windowStart + 1;
        setWindowStart(newStart);
        onPageChange(newStart);
      }
    };

    return (
      <nav aria-label="Page navigation example">
        <ul className="pagination custom_pagination">
          <li className={`page-item ${windowStart === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={handlePrevWindow}>
              <FaArrowLeft />
            </button>
          </li>

          {renderPageButtons()}

          <li
            className={`page-item ${
              windowStart >= totalPages ? "disabled" : ""
            }`}
          >
            <button className="page-link" onClick={handleNextWindow}>
              <FaArrowRight />
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  const handleSortBy = (sortType) => {
    setSortFilter(sortType);

    const sortedTokens = [...userData].sort((a, b) => {
      switch (sortType) {
        case "APY %":
          return parseFloat(b.apy || 0) - parseFloat(a.apy || 0);
        case "Latest":
          return new Date(b.createdAt) - new Date(a.createdAt);
        case "Market Cap":
          return parseFloat(b.marketCap || 0) - parseFloat(a.marketCap || 0);
        case "Alphabetical":
          return a.fundName.localeCompare(b.fundName);
        default:
          return 0;
      }
    });

    setuserData(sortedTokens);
  };

  return (
    <>
      <>
        <AdminHeader />

        <main className="main_flx userMang_main">
          <AdminSidebar />

          <div className="right_wrap pb-4">
            <div>
              <h3 className="inspge_title">Token Management</h3>

              <div className="search_select_wrp usrMng_selct_wrp">
                <div className="pdf_csv_wrp">
                  <button>
                    {" "}
                    <PDFDownloadLink
                      document={<TokenHistoryPDF data={userDataCSV} />}
                      fileName="token_report.pdf"
                    >
                      PDF
                    </PDFDownloadLink>
                  </button>
                  <button>
                    <CSVLink data={userDataCSV} filename={"my-data.csv"}>
                      csv
                    </CSVLink>
                  </button>
                </div>
                <div className="search_main">
                  <input
                    src="text"
                    placeholder="Search by Fund name or Asset type"
                    value={searchTerm}
                    maxLength={20}
                    onChange={handleFilterChange}
                  />
                  <IoSearch />
                  {/* <span className="admin_search_outer"></span> */}
                </div>

                <div className="select_main">
                  <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Sort by : <span>{sortFilter}</span>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => handleSortBy("APY %")}
                        >
                          APY %
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => handleSortBy("Latest")}
                        >
                          Latest
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => handleSortBy("Market Cap")}
                        >
                          Market Cap
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => handleSortBy("Alphabetical")}
                        >
                          Alphabetical
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="userMnge_table_wrp">
                <div className="table-respo usermnge_table_main table-common">
                  {/* {loader == true ? (
                    <span className="loader_user">
                      <CircularProgress size={40} />
                    </span>
                  ) : ( */}
                  <>
                    <div className="table">
                      <div className="thead">
                        <div className="tr">
                          <span className="th tbl_serlno">S:NO</span>
                          <span className="th">Fund Name</span>
                          <span className="th">Asset Type</span>
                          <span className="th">Token Price</span>
                          <span className="th">Total Supply</span>
                          <span className="th">Fund Term</span>
                          <span className="th">Token Contract</span>
                          <span className="th">Created Date</span>
                        </div>
                      </div>

                      {loader ? (
                        <>
                          <div className="tbody">
                            {Array.from({ length: 5 }).map((_, index) => (
                              <div className="tr" key={index}>
                                <span className="table_td td tbl_serlno">
                                  <Skeleton
                                    variant="text"
                                    className="table_skl_txt"
                                  />
                                </span>
                                <span className="table_td td">
                                  <Skeleton
                                    variant="text"
                                    className="table_skl_txt"
                                  />
                                </span>
                                <span className="table_td td">
                                  <Skeleton
                                    variant="text"
                                    className="table_skl_txt"
                                  />
                                </span>
                                <span className="table_td td">
                                  <Skeleton
                                    variant="text"
                                    className="table_skl_txt"
                                  />
                                </span>
                                <span className="table_td td">
                                  <Skeleton
                                    variant="text"
                                    className="table_skl_txt"
                                  />
                                </span>
                                <span className="table_td td">
                                  <Skeleton
                                    variant="text"
                                    className="table_skl_txt"
                                  />
                                </span>
                                <span className="table_td td">
                                  <Skeleton
                                    variant="text"
                                    className="table_skl_txt"
                                  />
                                </span>
                                <span className="table_td td">
                                  <Skeleton
                                    variant="text"
                                    className="table_skl_txt"
                                  />
                                </span>
                              </div>
                            ))}
                          </div>

                          <div className="mt-4 d-flex align-items-center justify-content-center gap-3">
                            <Skeleton
                              variant="circular"
                              className="skl_pagination_icon"
                            />
                            <Skeleton
                              variant="circular"
                              className="skl_pagination_icon"
                            />
                            <Skeleton
                              variant="circular"
                              className="skl_pagination_icon"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="tbody">
                            {userData.length > 0 ? (
                              userData.map((item, index) => {
                                return (
                                  <div className="tr">
                                    <span className="table_td td tbl_serlno">
                                      {index + 1}
                                    </span>
                                    <span className="table_td td">
                                      {item.fundName}
                                    </span>
                                    <span className="table_td td">
                                      {item.assetType}
                                    </span>{" "}
                                    <span className="table_td td">
                                      {item.tokenPrice} USDT
                                    </span>
                                    <span className="table_td td">
                                      {item.availableTokens}
                                    </span>
                                    <span className="table_td td">
                                      {item.fundTerm}
                                    </span>
                                    {/* <span className='table_td td'>{obfuscateEmail(item.walletID)}</span> */}
                                    <span className="table_td td">
                                      <Link
                                        target="_blank"
                                        className="copy-td-text"
                                        to={`https://testnet.bscscan.com/address/${item.TokenAddress}`}
                                      >
                                        <span>
                                          <img
                                            onClick={() =>
                                              copy(
                                                item.TokenAddress,
                                                "Wallet Address"
                                              )
                                            }
                                            src={copy_icon}
                                            alt="copy_icon"
                                            className="copy_icon"
                                          />
                                        </span>
                                        {shortenAddress(item.TokenAddress)}
                                      </Link>
                                    </span>
                                    {/* <span className="table_td td">
                                {item.email}
                              </span> */}
                                    <span className="table_td td">
                                      {moment(item.createdAt).format("lll")}
                                    </span>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="tr">
                                <span className="table_td td">
                                  <div className="nodata_wrap">
                                    <img
                                      src={
                                        new URL(
                                          "../../assets/No-data.webp",
                                          import.meta.url
                                        )
                                      }
                                      alt=""
                                      className="no_data_img"
                                    />
                                    No record found
                                  </div>
                                </span>
                              </div>
                            )}
                          </div>

                          {userData.length > 0 ? (
                            <div className="paginationcss">
                              <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={(page) => {
                                  handlePageClick(page);
                                }}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </div>
                  </>
                  {/* )} */}
                </div>
              </div>
            </div>
            {/* <div className="dsh_footer_wrap">
              <Footer />
            </div> */}
          </div>
        </main>
      </>
    </>
  );
};

export default UserManagement;
